<template>
    <div>
  <top-navbar></top-navbar>
  <div class=" mb-5 background_color" >
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Purchasing</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Manage Purchase Order</h6>

      <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" @input="loadMiinventory()" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>


   



    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
  </div>

        </div>
    

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

        <button  @click="componentPoCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-1 bdr-rad">  Create Purchase Order</button>
     

        <div>
  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>

 
</div>
  
      </div>
    </div>
    <div class="card bdr-rad2 mt-1 shadow p-2 ">
    <div class="card-body " >
<div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>


       <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->
   
  <div class="table-responsive">
   

    <b-table responsive style="font-size: small;"  class=" table-hover "
      :items="all_datas"
      :fields="fields"
      :current-page="currentPage"
     
      head-variant="dark"      
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
    
    >
   
    <!-- @filtered="onFiltered" -->
]
      <template #cell(actions)="row">
      
     
        <!-- <button  style=" font-size: small;"
         @click="Viewpage(row.item.id)" class="mr-1 btn   btn-outline-primary btn-sm mb-1 bdr-rad">
          View
        </button>
      
        <button  style=" font-size: small;"
         @click="Update(row.item.id)" v-if="row.item.statusvalue==1" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Update
        </button>
        <button  style=" font-size: small;"
         @click="Confimmodel(row.item.id)" v-if="row.item.statusvalue==1" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Confirm
        </button>
        <button  style=" font-size: small;"
         @click="Creategin(row.item.id)" v-if="row.item.statusvalue==3" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Create GIN
        </button>
        <button v-if="row.item.statusvalue!=1"  @click="generatePDF(row.item.id)"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button> -->

        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor" @click="Viewpage(row.item.id)">View</a>
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue==1"  @click="Update(row.item.id)">Update</a>
    <a class="dropdown-item mouse-cursor"  v-if="row.item.statusvalue==1"  @click="Confimmodel(row.item.id)">Confirm</a>
 
    <a class="dropdown-item mouse-cursor" v-if="row.item.statusvalue!=1"    @click="generatePDF(row.item.id)"> Print</a>
   
  </div>
</div>
       
      </template>

      <template #cell(number)="row">
        {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
     
       
        
      </template>
      <template #cell(P_code1)="row">
       <a href="/" > {{ row.item.P_code }}</a>
</template>

     
    </b-table>



    <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
        <b-pagination 
      @change="pageChanged" 
      v-model="currentPage" 
      pills 
      :total-rows="totalRows" 
      :per-page="perPage" 
      size="sm">
    </b-pagination>
    </b-col>

  </div>

  </div>
 
  <b-modal   :id="infoModal.id" :title="infoModal.content.C_code"  hide-footer >
    <div class="card">
      <div class="card-body">


        <table style="font-size: small; " class="table  table-sm  ">
       
          <tbody >
   
            <tr >
              <td style="border: 0px;" ><b>Id </b></td>
             <td style="border: 0px;">{{ infoModal.content.idCustomer }}</td> 
            </tr>
            <tr>
              <td><b>Name of Homeowner </b></td>
             <td>{{ infoModal.content.C_name }}</td> 
            </tr>
            <tr>
              <td><b>Address Line 1 </b></td>
             <td>{{ infoModal.content.C_address_line1 }}</td> 
            </tr>
           
            <tr>
              <td><b>Address Line 2 </b></td>
             <td>{{ infoModal.content.C_address_line2 }}</td> 
            </tr>
            <tr>
              <td><b>Address Line 3 </b></td>
             <td>{{ infoModal.content.C_address_line3 }}</td> 
            </tr>
            <tr>
              <td><b>Apt Phone </b></td>
             <td>{{ infoModal.content.C_contact_tel1 }}</td> 
            </tr>
            <tr>
              <td><b>Service charge/<br> Sinking fund </b></td>
             <td>{{ infoModal.content.billing_type }}</td> 
            </tr>
            <tr>
              <td><b>Created Date </b></td>
             <td>{{ infoModal.content.C_created_date }}</td> 
            </tr>
           
             
          </tbody>
   
   
        </table>

      </div>
    </div>

  </b-modal>
  
  
  </div>
    </div>

    <br><br>
  </div>
  </div>

  <content-footer></content-footer>
</div>
  
  
  </template>
  
  <script>
    import jsPDF from 'jspdf';
   import 'jspdf-autotable';
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'
   import DatePicker from 'vue2-datepicker';
   import 'vue2-datepicker/index.css';
  
  
  
  
  export default {
    components :{
       
        TopNavbar,
        ContentFooter,
        DatePicker,
    },
  
      mounted(){
    this.loadMiinventory()
      },
     
      computed: {
        
  
  
  
      },
  
      data(){
      return{
        isModalOpen: false,
        all_datas:[],
        alldata:{},
        all_code:{},
        total:{},
        details:[],
        total:{},
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        FromDate: null,
        ToDate: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage:15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'p_code', label: 'PO Code', sortable: true,  },
          { key: 'sup_name', label: 'Supplier', sortable: true  },
          { key: 'po_type', label: 'PO Type', sortable: true  },
          { key: 'p_purchasing_date', label: 'Purchase Date', sortable: true  },
          { key: 'p_followup_date', label: 'Follow up Date', sortable: true  },
          { key: 'p_due_date', label: 'Due Date', sortable: true  },
          { key: 'p_created_date', label: 'Created Date', sortable: true ,  },
          { key: 'p_created_by', label: 'Created By', sortable: true ,  },
          { key: 'status', label: 'Status', sortable: true ,  },
          { key: 'actions', label: 'Actions', sortable: true , class:'width-custom3', },
          
        ],
          
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        isLoading: true, 
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
       
       
      };
      },
  
      
  
  
     methods:{ 

      async componentPoCreate(){
        this.$router.push('/cpurchasing/create');
      },

   
      async generatePDF(id) {
        console.log("Amila");
      
      try {
        const { data} = await  axios.get('/ppurchasing/view?id='+id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.alldata = data.model;
         this.details = data.details;
         this.total = data.total;
    
        
        
      } catch (error) {
        console.log(error.response);
      }


      const doc = new jsPDF();

 

function addPageBorders(doc) {
const pageWidth = doc.internal.pageSize.width;
const pageHeight = doc.internal.pageSize.height;

// Set the border style
doc.setDrawColor(71, 144, 255); // Black color
doc.setLineWidth(15); // Border width

// Draw a line at the top of the page
doc.line(0, 0, pageWidth, 0);
// Draw a line at the bottom of the page
doc.line(0, pageHeight, pageWidth, pageHeight);
}
// Update this with your image URL or file path

var img = new Image()
img.src = '/img/evenware-logo.jpg'
img.onload = () => {
const imageWidth = doc.internal.pageSize.getWidth() - 500; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 4) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'jpg', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('Component PO', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Envision System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
doc.text('Nawala Road,', 10, 51, null, null);
doc.text('Rajagiriya,', 10, 54, null, null);
doc.text('Colombo 08,', 10, 57, null, null);
doc.text('Sri Lanka', 10, 60, null, null);
doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Order To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
const supplierName = this.alldata.relatedToSupplier.sup_name;
const sup_address_1 = this.alldata.relatedToSupplier.sup_address_1;
const sup_address_2 = this.alldata.relatedToSupplier.sup_address_2;
const sup_address_3 = this.alldata.relatedToSupplier.sup_address_3;

doc.text(supplierName, 85, 48);
doc.text(sup_address_1, 85, 51, null, null);
doc.text(sup_address_2, 85, 54, null, null);
doc.text(sup_address_3, 85, 57, null, null);






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('PO Code:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.p_code, 200, 49, null, null, 'right');


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Supplier:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(supplierName, 200, 56, null, null, 'right');
let stock_order = ''; // Use `let` for variables that may change

if (this.alldata.stock_order == null) {
stock_order = ''; // Assign an empty string if stock_order is empty
} else {
stock_order = this.alldata.stock_order; // Assign the value from alldata
}


doc.setFont('Helvetica', 'bold');
doc.text('Stock Order:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(stock_order, 200, 63, null, null, 'right');
doc.setFontSize(10);






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Purchasing Date:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.p_purchasing_date, 200, 70, null, null, 'right');

const tableData = [
  ['No', 'Product Code', 'Product Description', 'Requested Qty', 'GRN Qty', 'Unit Price	', 'Total']
];


this.details.forEach(detail => {
  tableData.push([
      detail.no,
      detail.P_code,
      detail.P_description,
      { content: detail.p_qty, styles: { halign: 'right' } },
      { content: detail.grn_qty, styles: { halign: 'right' } },
      { content: detail.p_product_price, styles: { halign: 'right' } },
     
   
      { content: detail.p_total, styles: { halign: 'right' } },
     
     
    
  ]);
});

  // Add table to the PDF
  doc.autoTable({
        startY: 85, // Y position to start the table
        head: [tableData[0]], // Table header
        body: tableData.slice(1),
        addPageContent: function(data) {
    addPageBorders(doc); // Call the function to add page borders
},
styles: {
    font: 'Helvetica',
    fontSize:8,
},
      // Table data excluding header
  });

  
  const tableBottomY = doc.lastAutoTable.finalY;

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');

 

  doc.setFontSize(9);
    doc.setFont('Helvetica', 'normal');
  doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+50, null, null);
  doc.text('* Settlement should be made within 5 days', 10, tableBottomY+55, null, null);
  doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+60, null, null);
  doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+65, null, null);
  doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+70, null, null);
  doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+75, null, null);
  

  // doc.output('dataurlnewwindow');

  
  const blob = doc.output('blob');
const url = URL.createObjectURL(blob);
window.open(url, '_blank');
};

},



  
     
  async Viewpage(id) {
  
    this.$router.push('/cpurchasing/view?id='+id);
   
  },
 
  async Update(id){
        this.$router.push('/cpurchasing/update?id='+id);
      },
      async Creategin(id){
        this.$router.push('/gin/createsogin?id='+id);
      },

      async Confimmodel(id){
        this.infoModal1.content = id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },
  
     

    // onFiltered(filteredItems) {
    //    
    //     this.totalRows = filteredItems.length
    //     this.currentPage = 1
        
    //   },
  
      async loadMiinventory(page = this.currentPage) {
       
      try {
       // this.isLoading = true;
        const { data } = await axios.get('/ppurchasing/index', {
          params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },
    pageChanged(newPage) {
      console.log(newPage);
      if (newPage !== this.previousPage) {
        console.log("Page changed to:", newPage);
        this.previousPage = newPage; // Update previous page tracker
        this.loadMiinventory(newPage);
      }
    },

    async Confirm(id) {
       
    
       try {
         const { data} = await  axios.get('/ppurchasing/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     
  
   
  
  
  
  
  
  }
  
  
  
  
  };
  
  </script>

  <style>

.button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }
  .manage-boder{
    border-bottom: 1px solid #E9E9E3;
    border-top: 1px solid #E9E9E3;
  }
  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #E9E9E3;
      border-top: 2px solid #E9E9E3;
      padding-bottom: 10px !important;
      padding-top: 10px !important;
      
      }
      .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;
          
      }
      .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
    .width7{
      width: 250px;
    }
    .bg-mycoolor{
      background-color: #a4d2f3 !important;

    }
   
  .modal-footer{
    text-align: right !important;
    display: block;
  }

  .mx-input {

    height: 31px !important;
  }

</style>
  
  